import { render } from "./WorkflowComponent.vue?vue&type=template&id=663ee591&scoped=true"
import script from "./WorkflowComponent.vue?vue&type=script&lang=js"
export * from "./WorkflowComponent.vue?vue&type=script&lang=js"

import "./WorkflowComponent.vue?vue&type=style&index=0&id=663ee591&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663ee591"]])

export default __exports__